define('Jeske.PLPBrandName.PLPModule.View'
	,   [
		'SCView'
		, 'jeske_plpbrandname_plpmodule.tpl'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
		]
	,   function (
		SCViewComponent
		, jeske_plpbrandname_plpmodule_tpl
		, Backbone
		, jQuery
		, _
		)
	{
		'use strict';
	
		var SCView = SCViewComponent.SCView;
	
		function PLPModuleView(options) {
			SCView.call(this, options);

			this.options = options || {};
			this.container = options.container;
			this.brand = null;

			this.template = jeske_plpbrandname_plpmodule_tpl;

			this.contextDataRequest = ['item'];
		}
		
		// Inherit parent instance methods.
		PLPModuleView.prototype = Object.create(SCView.prototype);
	
		// Restore the constructor.
		PLPModuleView.prototype.constructor = PLPModuleView;
	
		PLPModuleView.prototype.getContext = function() {
			// Rehydration guard: on the SEO-prerender attach path getContext() can be
			// called before contextData.item is populated. Bail out safely instead of
			// throwing (which would collapse the whole PLP view tree).
			var item = (this.contextData && typeof this.contextData.item === 'function')
				? this.contextData.item()
				: null;

			if (!item) {
				return {};
			}

			var context = {
				brand: item.custitem_brand
			};

			// Rehydration fix: confirmed empirically that on the attach path, this.el is a
			// detached Backbone-created element (isConnected: false) - it is NOT the real,
			// visible <div data-view="ItemViews.Brand"> placeholder already sitting in the
			// prerendered page, so writing into this.el never reaches the screen. The real
			// placeholder for this specific product cell is identified by data-item-id
			// (confirmed the value matches item.internalid exactly), but querying for it
			// synchronously here found zero matches - getContext() appears to run before
			// the browser has finished parsing this cell's markup into the live DOM.
			// Deferring the query/write to document-ready lets it run once parsing has
			// actually completed. Harmless on the classic path - the framework's own
			// render cycle overwrites this with the same content moments later regardless.
			if (item.internalid) {
				var internalId = item.internalid;
				jQuery(function () {
					jQuery('[data-item-id="' + internalId + '"]')
						.find('[data-view="ItemViews.Brand"]')
						.first()
						.html(jeske_plpbrandname_plpmodule_tpl(context));
				});
			}

			return context;
		}

		PLPModuleView.prototype.validateContextDataRequest = function() {
			// Reverted to unconditional true: gating this on contextData.item()
			// availability broke rendering on the classic (non-rehydration) path too,
			// confirmed empirically in the sandbox - item context is evidently not
			// guaranteed ready by the time this is evaluated even on a normal load for
			// this view's registration path (PLP.addChildView('ItemViews.Brand', ...)).
			// Crash-safety is still handled by the null guard in getContext() above;
			// the rehydration blank-brand-name state remains an open issue pending
			// further investigation into SC's real per-item child view lifecycle.
			return true;
		}
	
		// Return the AMD constructor.
		return PLPModuleView;
	});
